import React from 'react';

const LoadingScreen = ({ message, imageUrl, videoUrl }) => {


  return (
  <div className="fixed inset-0 flex flex-col items-center justify-center z-50 p-4 sm:p-6 md:p-8" style={{backgroundImage: 'url(/assets/images/background.jpg)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
    {/* Video si hay videoUrl */}
    {videoUrl && (
      <div className="mb-4 sm:mb-6 mt-2 w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
        <video 
          src={videoUrl}
          className="rounded-lg shadow-md w-full h-auto max-h-[50vh] sm:max-h-[60vh] md:max-h-96 object-contain"
          autoPlay
          loop
          playsInline
          controls
        >
          Tu navegador no soporta videos HTML5.
        </video>
      </div>
    )}
    
    {/* Imagen si hay imageUrl y no hay videoUrl */}
    {imageUrl && !videoUrl && (
      <div className="mb-4 sm:mb-6 mt-2 w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
        <img
          src={imageUrl}
          alt="Procesando"
          className="rounded-lg shadow-md w-full h-auto max-h-[50vh] sm:max-h-[60vh] md:max-h-96 object-contain"
        />
      </div>
    )}
    
    {/* Spinner revisado */}
    <div className="flex flex-col items-center space-y-2 sm:space-y-3 mt-2 sm:mt-4">
      <div 
        className="animate-spin h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 rounded-full border-4 border-gray-300 border-t-red-500"
      />
      <p className="text-base sm:text-lg md:text-xl font-semibold text-gray-700 text-center px-4">
        {message || 'Cargando...'}
      </p>
    </div>
  </div>
);
}
export default LoadingScreen;
